angular.module('impactx.cscontract').controller('CSCOutletsCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    CSCOutletsCtrl
]);

function CSCOutletsCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService, PartialDialogsService) {
    var self = this;

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {outlets: $scope.data}, "/cscontract/outlets/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'cscoutlets', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/outlets/view").then(function () {
        $scope.saveTrns = TranslationService.get("save");
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.saveTrns,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}